import request from '@/utils/request';

export function getorderlist(data) {
	return request({
		url: 'user/get-order-list',
		method: 'get',
		params: data,
	});
}

export function preview(data) {
	return request({
		url: 'order/preview',
		method: 'post',
		data: data,
	});
}

export function previewOneKey(data) {
	return request({
		url: 'order/preview-by-one-key',
		method: 'post',
		data: data,
	});
}

export function orderDdd(data) {
	return request({
		url: '/order/add',
		method: 'post',
		data,
	});
}

export function getOrderinfo(data) {
	return request({
		url: 'user/get-order-info',
		method: 'get',
		params: data,
	});
}

export function payDopay(data) {
	return request({
		url: '/pay/dopay',
		method: 'post',
		data,
	});
}

export function cancelorder(data) {
	return request({
		url: 'user/cancel-order',
		method: 'post',
		data: data,
	});
}

export function confirmOrder(data) {
	return request({
		url: 'user/confirm-order',
		method: 'post',
		data: data,
	});
}

export function repay(data) {
	return request({
		url: '/order/repay',
		method: 'post',
		data,
	});
}
